module.exports = __webpack_public_path__ + "img/Emerson-Balbin.8a754a6d.jpg";